var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionAttachTrack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4H2V20H4V4Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4H16L16 9L18 9V4Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15L16 15L16 20H18V15Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8V4H9V8H11Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10H9V14H11V10Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16H11V20H9V16Z",
    fill: "#727272"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4L13 10C13 11.6569 14.3431 13 16 13L19 13C19.5523 13 20 13.4477 20 14L20 20L22 20L22 14C22 12.3431 20.6569 11 19 11L16 11C15.4477 11 15 10.5523 15 10L15 4L13 4Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionAttachTrack);
export default __webpack_public_path__ + "static/media/ic_action_attach_track.7dc0582b8463ca93074c59bff8106b03.svg";
export { ForwardRef as ReactComponent };